// @ts-nocheck
(function () {
  'use strict';

  if (!window.__locationFinderFilterBound) {
    window.__locationFinderFilterBound = true;
    document.addEventListener('location-finder:filter', function (event) {
      const county = event.detail && event.detail.county;
      document.querySelectorAll('[data-location-finder]').forEach(function (root) {
        const apply = root._applyFilter;
        if (typeof apply === 'function') apply(county);
      });
    });
  }

  function flyTo(map, location) {
    if (!map || !location || typeof location.lat !== 'number') return;
    map.flyTo({
      center: [location.lng, location.lat],
      zoom: 12,
      essential: true,
      duration: 900
    });
  }

  function scrollListToItem(root, item) {
    const listWrap = root.querySelector('.location-finder__list-wrap');
    if (!listWrap || !item) return;
    const wrapRect = listWrap.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const offset = itemRect.top - wrapRect.top + listWrap.scrollTop - 16;
    listWrap.scrollTo({ top: offset, behavior: 'smooth' });
  }

  function expandItem(root, item) {
    if (!item) return;
    item.setAttribute('data-expanded', 'true');
    const head = item.querySelector('.location-finder-item__head');
    if (head) head.setAttribute('aria-expanded', 'true');
  }

  function initFinder(root) {
    if (!root || root.dataset.locationFinderInitialised === 'true') return;
    const dataEl = root.querySelector('[data-location-finder-data]');
    if (!dataEl) return;

    const token = root.dataset.mapboxToken;
    const styleUrl = root.dataset.mapboxStyle;
    const mapEl = root.querySelector('[data-location-finder-map]');
    if (!token || !mapEl || !window.mapboxgl) return;

    let locations = [];
    try {
      locations = JSON.parse(dataEl.textContent) || [];
    } catch (err) {
      return;
    }

    const byHandle = {};
    locations.forEach(function (location) { byHandle[location.handle] = location; });
    const withCoords = locations.filter(function (location) {
      return typeof location.lng === 'number' && typeof location.lat === 'number';
    });

    while (mapEl.firstChild) mapEl.removeChild(mapEl.firstChild);
    const placeholder = root.querySelector('.location-finder__map-placeholder');
    if (placeholder) placeholder.style.display = 'none';

    window.mapboxgl.accessToken = token;
    const map = new window.mapboxgl.Map({
      container: mapEl,
      style: styleUrl || 'mapbox://styles/mapbox/light-v11',
      center: [-8.0, 53.4],
      zoom: 6,
      attributionControl: { compact: true }
    });

    map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

    let initialBounds = null;
    map.on('load', function () {
      const bounds = new window.mapboxgl.LngLatBounds();
      withCoords.forEach(function (location) {
        const el = document.createElement('button');
        el.type = 'button';
        el.className = 'location-finder-marker location-finder-marker--' + (location.group || 'shops');
        el.setAttribute('aria-label', location.name);
        el.dataset.locationHandle = location.handle;
        new window.mapboxgl.Marker({ element: el, anchor: 'bottom' })
          .setLngLat([location.lng, location.lat])
          .addTo(map);
        bounds.extend([location.lng, location.lat]);
      });
      if (!bounds.isEmpty()) {
        initialBounds = bounds;
        map.fitBounds(bounds, { padding: 60, maxZoom: 9, duration: 0 });
      }
    });

    root.dataset.locationFinderInitialised = 'true';

    function applyFilter(rawCounty) {
      const county = (rawCounty || '').toLowerCase().trim();
      const items = root.querySelectorAll('[data-location-finder-item]');
      const visibleHandles = {};
      items.forEach(function (item) {
        const match = !county || (item.getAttribute('data-county') || '').toLowerCase().trim() === county;
        item.style.display = match ? '' : 'none';
        if (match) visibleHandles[item.getAttribute('data-handle')] = true;
      });

      root.querySelectorAll('.location-finder-marker').forEach(function (marker) {
        const match = !county || visibleHandles[marker.dataset.locationHandle];
        marker.style.display = match ? '' : 'none';
      });

      root.querySelectorAll('.location-finder__group').forEach(function (group) {
        const visible = group.querySelectorAll('[data-location-finder-item]:not([style*="display: none"])').length;
        const countEl = group.querySelector('.location-finder__group-count-dynamic');
        if (countEl) countEl.textContent = visible;
        group.style.display = visible === 0 ? 'none' : '';
      });

      const groupBounds = new window.mapboxgl.LngLatBounds();
      const groupHandles = Object.keys(visibleHandles);
      groupHandles.forEach(function (handle) {
        const location = byHandle[handle];
        if (location && typeof location.lat === 'number') groupBounds.extend([location.lng, location.lat]);
      });
      if (!groupBounds.isEmpty() && groupHandles.length > 0) {
        map.fitBounds(groupBounds, { padding: 60, maxZoom: 11, duration: 700 });
      } else if (initialBounds && !initialBounds.isEmpty()) {
        map.fitBounds(initialBounds, { padding: 60, maxZoom: 9, duration: 700 });
      }
    }

    root._applyFilter = applyFilter;

    function highlightMarker(handle) {
      root.querySelectorAll('.location-finder-marker').forEach(function (marker) {
        marker.classList.toggle('is-active', marker.dataset.locationHandle === handle);
      });
    }

    root.addEventListener('click', function (event) {
      const marker = event.target.closest('.location-finder-marker');
      if (marker) {
        const handle = marker.dataset.locationHandle;
        const item = root.querySelector('[data-location-finder-item][data-handle="' + handle + '"]');
        if (item) {
          expandItem(root, item);
          scrollListToItem(root, item);
        }
        flyTo(map, byHandle[handle]);
        highlightMarker(handle);
        return;
      }

      const head = event.target.closest('.location-finder-item__head');
      if (head) {
        const itemEl = head.closest('[data-location-finder-item]');
        if (!itemEl) return;
        const willExpand = itemEl.getAttribute('data-expanded') !== 'true';
        if (willExpand) {
          const itemHandle = itemEl.dataset.handle;
          flyTo(map, byHandle[itemHandle]);
          highlightMarker(itemHandle);
        } else {
          highlightMarker(null);
          if (initialBounds && !initialBounds.isEmpty()) {
            map.fitBounds(initialBounds, { padding: 60, maxZoom: 9, duration: 700 });
          }
        }
      }
    });
  }

  function ensureMapboxAndInit() {
    const roots = document.querySelectorAll('[data-location-finder]');
    if (!roots.length) return;
    if (window.mapboxgl) {
      roots.forEach(initFinder);
      return;
    }
    const existing = document.querySelector('script[data-mapbox-gl]');
    if (existing) {
      existing.addEventListener('load', function () {
        roots.forEach(initFinder);
      });
      return;
    }
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.6.0/mapbox-gl.css';
    document.head.appendChild(css);
    const js = document.createElement('script');
    js.src = 'https://api.mapbox.com/mapbox-gl-js/v3.6.0/mapbox-gl.js';
    js.dataset.mapboxGl = 'true';
    js.async = true;
    js.addEventListener('load', function () {
      roots.forEach(initFinder);
    });
    document.head.appendChild(js);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureMapboxAndInit);
  } else {
    ensureMapboxAndInit();
  }
})();
